import { Outlet, Link } from "react-router-dom";
import { Toggle } from "./components";

const App = () => {
  return (
    <>
      <div className="absolute right-1 md:mr-3 md:mt-3">
        <Toggle />
      </div>
      <div className=" flex flex-col p-5  h-full  items-center">
        <Link
          to="/home"
          as="h1"
          className="cursor-pointer dark:text-white text-black text-3xl md:text-4xl font-medium mb-2 max-w-sm sm:max-w-2xl text-center"
        >
          CREATE Foundation US Open Webcasts
        </Link>

        <Outlet />
      </div>
    </>
  );
};

export default App;
